module.exports = __webpack_public_path__ + "static/media/check-remaining-traffic_2.9ff21a5f.png";